import { Injectable } from '@angular/core';
import { padStart } from 'lodash';
import { TrackedTime } from '../../../tracked-time-data/models/tracked-time.model';
import { DateTimeService, MOMENT_MONTH_YEAR_DATE_FORMAT } from 'i2g-ng-utils';

@Injectable()
export class TimeEntryDialogBuilder {
  constructor(private _dateTimeService: DateTimeService) {}

  buildGroupByFn(): (timeEntry: TrackedTime) => any {
    return (timeEntry: TrackedTime) => {
      const { year, month } = this._dateTimeService.parse(timeEntry.startDate);

      return this._formatDate(year, month + 1);
    };
  }

  private _formatDate(year: number, month: number, day?: number): string {
    const mm: string = padStart(month.toString(10), 2, '0');
    const dd: string = padStart((day || 1).toString(10), 2, '0');

    return this._dateTimeService.formatDate(
      `${year}-${mm}-${dd}`,
      MOMENT_MONTH_YEAR_DATE_FORMAT
    );
  }
}
